import React, { Component } from 'react';
import ActivityForm from './ActivityForm';
import { connect } from 'react-redux';
import * as activityActions from 'actions/activityActions';
import * as tripActions from 'actions/tripActions';
import { debounce } from 'lodash';

class CreateActivityContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lng: 0,
      lat: 0,
      sub_category: [],
    };
  }

  componentDidMount() {
    const {
      getActivity,
      match: { params },
    } = this.props;
    getActivity(params.id);
  }

  componentDidUpdate(prevProps) {
    const { places, activity, getDestinations, refreshCoordinates } = this.props;

    if (prevProps !== this.props) {
      if (prevProps.places !== places) {
        // When click in the map, select the first option
        this.setState({
          address: places.length > 0 && places[0].place_name,
          showPlaceList: true,
        });
      }
      if (!this.state.latitude) {
        // update state when the activity is in redux (edit)
        this.setState({
          ...activity,
          lat: activity.latitude,
          lng: activity.longitude,
          city_id: activity.city_id,
          city_name: activity.city.name,
        });
        this.selectPlace({
          center: [activity.longitude, activity.latitude],
          place_name: activity.address,
        });
        refreshCoordinates(activity.address);
        getDestinations({ search: activity.city_name });
      }
    }
  }

  handleChange = evt => {
    this.setState({ [evt.target.name]: evt.target.value });
    if (evt.target.name == 'category') {
      this.setState({ sub_category: [] });
    }
  };

  updateImage = response => {
    this.setState({ changeAvatar: false, image: response.url });
  };

  clickMap = (map, evt) => {
    const { refreshAddress } = this.props;
    const { lng, lat } = evt.lngLat;
    refreshAddress({ lng, lat });
    this.setState({ lng, lat });
  };

  searchCoordinates = debounce(async () => {
    const { refreshCoordinates } = this.props;
    const { address } = this.state;

    refreshCoordinates(address);
  }, 600);

  handleChangeAddress = event => {
    const address = event.target.value;

    this.setState({ address, addressInput: address });
    this.searchCoordinates();
  };

  selectPlace = place => {
    const { center, place_name } = place;
    this.setState({
      lng: center[0],
      lat: center[1],
      address: place_name,
      addressInput: place_name,
    });
  };

  changeTags = (value, arrayName) => {
    const array = [...this.state[arrayName]];
    const exist = array.indexOf(value);
    if (exist != -1) {
      array.splice(exist, 1);
    } else {
      array.push(value);
    }
    this.setState({
      [arrayName]: array,
    });
  };

  searchData = debounce(async => {
    const { getDestinations } = this.props;
    const { city_name } = this.state;
    getDestinations(city_name);
  }, 600);

  searchCity = event => {
    const search = event.target.value;
    this.setState({ city_name: search });
    this.searchData();
  };
  replaceImage = () => {
    this.setState({ image: null });
  };
  update = () => {
    const {
      updateActivity,
      match: { params },
    } = this.props;

    this.setState({ latitude: this.state.lat, longitude: this.state.lng }, () =>
      updateActivity({ ...this.state }, params.id),
    );
  };

  selectCity = city => {
    this.setState({ city_id: city.id, city_name: city.name });
  };

  updateShowCityList = status => {
    this.setState({ showCityList: status });
  };

  updateShowPlaceList = status => {
    this.setState({ showPlaceList: status });
  };

  handleChangeBussyHours = (evt, index) => {
    const value = evt.target.value;
    let new_bussy_hours = [...this.state.bussy_hours];
    new_bussy_hours[index] = value;
    this.setState({ bussy_hours: new_bussy_hours });
  };
  handleChangeCheckbox = (evt, name) => {
    this.setState({ [name]: evt.target.checked });
  };

  render() {
    return (
      <ActivityForm
        handleChange={this.handleChange}
        updateImage={this.updateImage}
        clickMap={this.clickMap}
        handleChangeAddress={this.handleChangeAddress}
        selectPlace={this.selectPlace}
        changeTags={this.changeTags}
        saveOrUpdate={this.update}
        searchCity={this.searchCity}
        selectCity={this.selectCity}
        replaceImage={this.replaceImage}
        updateShowCityList={this.updateShowCityList}
        updateShowPlaceList={this.updateShowPlaceList}
        handleChangeCheckbox={this.handleChangeCheckbox}
        handleChangeBussyHours={this.handleChangeBussyHours}
        editMode
        {...this.props}
        data={this.state}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    places: state.activityReducer.places,
    citiesFiltered: state.tripReducer.tripForm.citiesFiltered,
    token: state.loginReducer.token,
    activity: state.activityReducer.activity,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    refreshCoordinates: address => dispatch(activityActions.refreshCoordinates(address)),
    refreshAddress: address => dispatch(activityActions.refreshAddress(address)),
    updateActivity: (activity, id) => dispatch(activityActions.updateActivity(activity, id)),
    getDestinations: params => dispatch(tripActions.getDestinations(params)),
    getActivity: id => dispatch(activityActions.getActivity(id)),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateActivityContainer);
